// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"a6f54efa","requiredAsterisk":"a35d7ea8","asterisk":"a0ff4f78","text":"d780fe1c","hasValue":"f039be59"};